import { PlusOutlined } from '@ant-design/icons';
import { Button, Flex, Skeleton } from 'antd';
import React, { useContext } from 'react';

import {
  EditSalesFunnelModal,
  EmptyComponentWithDataTestId,
  Error403Unauthorized,
  SalesFunnelColumnComponent,
} from '@app/components';
import { FORBIDDEN_ERROR_MAIN_PART, PREFIX } from '@app/constants';
import { useNewUserAccessRights } from '@app/hooks';
import { useEditSalesFunnelEffects } from '@app/pages/SalesFunnels/EditSalesFunnel/hooks/useEditSalesFunnelEffects';
import { EditSalesFunnelContext } from '@app/providers';

import { useEditSalesFunnel } from '@pages/SalesFunnels/EditSalesFunnel/hooks/useEditSalesFunnel';

import '@pages/SalesFunnels/EditSalesFunnel/styles/EditSalesFunnel.desktop.scss';

export const EditSalesFunnel: React.FC = () => {
  const {
    isSalesFunnelStagesLoading,
    currentSalesFunnelStages,
    salesFunnelId,
    refetchGetSalesFunnelStages,
    salesFunnelStagesError,
  } = useContext(EditSalesFunnelContext);

  const {
    userAccessRights: {
      SalesFunnels: { IsOn },
    },
  } = useNewUserAccessRights();

  const { memoizedRobotsWithProgress } = useEditSalesFunnelEffects();

  const {
    handleOpenSalesFunnelModal,
    isEditSalesFunnelModalOpen,
    isEditModal,
    editableSalesFunnelId,
    setIsEditSalesFunnelModalOpen,
    headerForm,
    currentSalesFunnelStage,
    setCurrentSalesFunnelStage,
    IsStageCreate,
  } = useEditSalesFunnel();

  if (isSalesFunnelStagesLoading) {
    return <Skeleton />;
  }

  if (salesFunnelStagesError) {
    return <EmptyComponentWithDataTestId />;
  }

  if (!IsOn) {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return (
    <div className={`${PREFIX}edit-sales-funnel`}>
      <Flex gap="middle" className="flex-component">
        {currentSalesFunnelStages.map((item) => (
          <SalesFunnelColumnComponent
            data={item}
            isEditPageComponent={true}
            key={item.Id}
            handleOpenSalesFunnelModal={handleOpenSalesFunnelModal}
            setCurrentSalesFunnelStage={setCurrentSalesFunnelStage}
            refetchGetSalesFunnelStages={refetchGetSalesFunnelStages}
            robotsWithProgress={memoizedRobotsWithProgress}
          />
        ))}
        {IsStageCreate && (
          <Button
            className="add-stage-button"
            onClick={() =>
              handleOpenSalesFunnelModal(Number(salesFunnelId), false)
            }
          >
            <Flex vertical={true} align="center">
              <PlusOutlined />
              Создать этап
            </Flex>
          </Button>
        )}
      </Flex>

      <EditSalesFunnelModal
        isEditSalesFunnelModalOpen={isEditSalesFunnelModalOpen}
        setIsEditSalesFunnelModalOpen={setIsEditSalesFunnelModalOpen}
        salesFunnelId={editableSalesFunnelId}
        currentSalesFunnelStages={currentSalesFunnelStages}
        currentSalesFunnelStage={currentSalesFunnelStage}
        setCurrentSalesFunnelStage={setCurrentSalesFunnelStage}
        isEditModal={isEditModal}
        refetchGetSalesFunnelStages={refetchGetSalesFunnelStages}
        headerForm={headerForm}
        isRegistryComponent={false}
        handleDeleteSalesFunnelStageClick={() => {}}
      />
    </div>
  );
};
